import type { Conductor } from "types/conductors.types"

import PopUp from "widgets/common/PopUp"
import ConductorSpec from "widgets/conductors/ConductorSpec"

interface ConductorSpecDialogProps {
  conductor: Conductor | undefined
  onClose: () => void
}

const ConductorSpecDialog = ({ conductor, onClose }: ConductorSpecDialogProps) => {
  if (!conductor) return null

  return (
    <PopUp open onClose={onClose} titleKey="conductors.CONDUCTOR" maxWidth="md" fullWidth>
      <ConductorSpec conductor={conductor} />
    </PopUp>
  )
}

export default ConductorSpecDialog
